<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : activeStep == step }" (click)="toggleOpen()">
        <span class="margin-right">Well Information</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">
    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Is your plat subject to a Unitization Order (ORC 1509.28)?
      @if (fieldHasNotes('unitization|subjectToOrder') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'unitization|subjectToOrder'" [notes]="getFilteredNotes('unitization|subjectToOrder')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-5 large-5 medium-5">
      @for (opt of yesNo; track opt) {
        <span class="padding-right"><input type="radio" formControlName="subjectToOrder" (ngModelChange)="orderSubjectChanged($event)" [value]="opt.id" /> {{opt.text}}</span>
      }
    </div>
    <div class="cell small-7 large-7 medium-7 bold padding-right">
      If your plat is subject to a Unitization Order (ORC 1509.28), enter the unit order number:
      @if (fieldHasNotes('unitization|orderNumber') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'unitization|orderNumber'" [notes]="getFilteredNotes('unitization|orderNumber')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">
      <input type="text" formControlName="orderNumber" />

    </div>
    <div class="cell small-3 medium-3 large-3">
      &nbsp;
    </div>
    <div class="cell small-7 medium-7 large-7 bold padding-right">
      If the size of the drilling unit changed, provide number of acres:
      @if (fieldHasNotes('unitization|platSize') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'unitization|platSize'" [notes]="getFilteredNotes('unitization|platSize')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">
      <input type="number" formControlName="platSize" />
    </div>
    <div class="cell small-3 medium-3 large-3">
      &nbsp;
    </div>
  </div>
</ng-container>